import { MINIMUM_ITEMS_TO_FIX_BUTTON_WRAPPER, MINIMUM_ITEMS_TO_SHOW_SEARCH } from './constants';

export function isLongList(list: number | undefined): boolean {
  if (!list) return false;
  if (list >= MINIMUM_ITEMS_TO_SHOW_SEARCH) return true;
  return false;
}

export function isMediumList(list: number | undefined): boolean {
  if (!list) return false;
  if (list >= MINIMUM_ITEMS_TO_FIX_BUTTON_WRAPPER) return true;
  return false;
}
